module.exports = __webpack_public_path__ + "static/media/bg38.0c9fd17e.jpg";